import React, { useState, useEffect } from 'react';
import { Radio, Input, Form, message, Card, Button } from 'antd';
import useSwr from '@hooks/useSwr';
import { useTranslation } from 'react-i18next';
import api from '@services/api';

const SmsConfig = () => {
  const [type, setType] = useState('yupChat');

  const [form] = Form.useForm();
  const { t: translate } = useTranslation('sms-send');
  const { data, mutate } = useSwr(`/service-proxy/sms-config`);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        apiKey: data.hasApiKey ? '********' : '',
        apiUrl: data.apiUrl || '',
      });

      if (data.partner === 'YUPCHAT') {
        form.setFieldsValue({
          apiSecret: data.hasApiSecret ? '********' : '',
        });
        setType('YUPCHAT');
      } else {
        setType('INFOBIP');
      }
    }
  }, [data, form]);

  const handleSave = () => {
    form.validateFields().then(async values => {
      try {
        await api.post('/service-proxy/sms-config', {
          ...(values.apiUrl && values.apiUrl !== ''
            ? { apiUrl: values.apiUrl.replace(/(?:https?:\/\/)[^\s]+/g, '') }
            : {}),
          ...(values.apiKey !== '********' ? { apiKey: values.apiKey } : {}),
          ...(values.apiSecret ? { apiSecret: values.apiSecret } : {}),
          partner: type,
        });
        message.success(translate('sender.created'));
        mutate();
      } catch (err) {
        message.error(translate('sender.error'));
      }
    });
  };

  return (
    <Card
      style={{
        width: '362px',
      }}
    >
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          marginBottom: '24px',
        }}
      >
        <Radio.Group
          onChange={({ target }) => setType(target.value)}
          value={type}
        >
          <Radio.Button value="YUPCHAT">YUPCHAT</Radio.Button>
          <Radio.Button value="INFOBIP">INFOBIP</Radio.Button>
        </Radio.Group>
      </div>

      <Form form={form} layout="vertical">
        {type === 'YUPCHAT' ? (
          <div
            style={{
              display: 'flex',
              gap: '8px',
              flexDirection: 'column',
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Form.Item
                name="apiKey"
                label={translate('sender.apiKey')}
                rules={[
                  { required: true, message: translate('sender.required') },
                ]}
                style={{ width: '50%' }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="apiSecret"
                label={translate('sender.apiSecret')}
                rules={[
                  { required: true, message: translate('sender.required') },
                ]}
                style={{ width: '50%' }}
              >
                <Input />
              </Form.Item>
            </div>
            <Form.Item
              name="apiUrl"
              label={translate('sender.apiUrl')}
              rules={[
                { required: true, message: translate('sender.required') },
              ]}
            >
              <Input />
            </Form.Item>
          </div>
        ) : (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Form.Item
              name="apiKey"
              label={translate('sender.apiKey')}
              rules={[
                { required: true, message: translate('sender.required') },
              ]}
              style={{ width: '50%' }}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="apiUrl"
              label={translate('sender.apiUrl')}
              rules={[
                { required: true, message: translate('sender.required') },
              ]}
              style={{ width: '50%' }}
            >
              <Input />
            </Form.Item>
          </div>
        )}
      </Form>
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button type="primary" onClick={() => handleSave()}>
          {translate('sender.save')}
        </Button>
      </div>
    </Card>
  );
};

export default SmsConfig;
